import PropTypes from "prop-types"
import React, { useState, useMemo } from "react"
import {
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Table,
  Input,
  Form,
  InputGroup,
  Card,
  CardBody,
} from "reactstrap"
import moment from "moment"
import round from "lodash/round"
import logodark from "../../assets/images/dark-logo.png"
import { convertUtcToLocal } from "helpers/util"
//redux
import { useSelector, useDispatch } from "react-redux"
import { seasonTypes } from "constants/common"

const InvoiceView = ({ modal = false, toggle, bill, gst }) => {

  const renderItems = bill => {
    if (bill?.billDesc && Array.isArray(bill?.billDesc)) {      
      
        const items = (bill?.billDesc || []).map((el, i) => {
          let showPrice = el.seasonType !== seasonTypes.Monthly
          let shortCode = el.carparkCode
          //console.log("shortCode", shortCode)

          return (
            <tr key={"key" + i}>
              <td>{i + 1}</td>
              {(el?.seasonType !== seasonTypes.Monthly) && (
                <td>
                  {(el?.vehicleNumber || "A00A")} {"-" + (el?.seasonTitle)}{" "}
                  {moment(el?.seasonStart).format("Do MMM YYYY")}
                  {", "}
                  {moment(el?.seasonStart).format("h:mm a")} - {" "}
                  {el?.seasonEnd ? moment(el?.seasonEnd).diff(moment(el?.seasonStart),"minutes") +"mins" : "00:00"}
                </td>
              )}
              {(el?.seasonType == seasonTypes.Monthly) &&
                (
                  <td>
                    {el?.seasonTitle} {" " + el?.carparkCode || "shortCode"}{" "}
                    {moment(el?.seasonStart).endOf("day").format("Do MMM YYYY")}
                    {"-"}
                    {moment(el?.seasonEnd).endOf("day").format("Do MMM YYYY")}
                  </td>
                )}
              {
                <td  className="text-end">
                  S$
                </td>
              }
              {
                <td  className="text-end">
                  {parseFloat(el?.total?.$numberDecimal).toFixed(2)}
                </td>
              }
            </tr>
          )
        })
        return items      
    } 
    return null
  }

  return (
    <Modal isOpen={modal} toggle={toggle} style={{ maxWidth: 800, width: 800 }}>
      <ModalHeader toggle={toggle} tag="h4">
        {"View Billing Details"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row className="invoice-title">
                  <Col xs="7">
                      <img
                        src={logodark}
                        alt=""
                        height="80"
                        className="auth-logo-dark"
                      />
                    </Col>
                    <Col xs="5" className="p-3 float-end">
                    <h4 className="text-start font-size-16">
                      Central Provident Fund Board<br />
                      238B Thomson Road<br />
                      #08-00 Tower B Novena Square<br />
                      Singapore 307685<br />
                      GST Reg No: MB-8100008-0
                    </h4>                     
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col xs="7">
                      <address>
                      
                        <strong>TAX INVOICE</strong><br />
                        Billed To:<br />                        
                        {bill?.userId?.name || "Johnsan Tan"} <br />
                        {bill?.userId?.department || "Operation"}
                        <br />{" "}
                        {/* {bill.billDesc[0].seasonTitle} */}
                      </address>
                      <br />
                      <address>
                        {bill?.userId?.corporateEmail || "sandy@cpf.com"} <br />{" "}
                        +65 {bill?.userId?.mobileNumber || "89015590"}
                      </address>
                    </Col>
                    <Col xs="5" className="p-3 float-end">
                      <h4 className="text-start font-size-16">
                          Invoice Number: {bill?.billId || "BLSD211-7055"}
                          <br />
                          Invoice Date: {moment(bill?.billDate).format("DD MMM YYYY") }
                      </h4>
                    </Col>
                  </Row>
                  <div className="py-2 mt-3">
                    <h3 className="font-size-15 fw-bold">Bill summary</h3>
                  </div>
                  <div className="table-responsive">
                    <Table className="table-nowrap">
                      <thead>
                        <tr>
                          <th style={{ width: "10px" }}>#</th>
                          <th>Item</th>
                          <th style={{width: "5%"}} className="text-end" colSpan="2">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderItems(bill)}
                       
                        <tr>
                            <td colSpan="2" className="text-end">
                              {`Price Before GST`}
                            </td>
                            <td  className="text-end">
                              S$
                            </td>
                           <td  className="text-end">
                              {parseFloat(
                                bill?.billGSTAmt?.$numberDecimal
                              ).toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" className="text-end">
                            GST {bill?.billGSTAmt?.$numberDecimal >0 ? 
                            parseFloat(bill?.billGST?.$numberDecimal*100/bill?.billGSTAmt?.$numberDecimal).toFixed(0):gst}%
                            </td>
                            <td  className="text-end">
                              S$
                            </td>
                            <td  className="text-end">
                              {parseFloat(
                                bill?.billGST?.$numberDecimal
                              ).toFixed(2)}
                            </td>
                          </tr>
                      
                        <tr>
                          <td colSpan="2" className="border-0 text-end">
                            <strong>Price Includes GST</strong>
                          </td>
                          <td  className="text-end">
                              S$
                          </td>
                           {bill ? (
                            <td  className="border-0 text-end">
                              {bill?.billAmount?.$numberDecimal ? (
                                <h4 className="m-0">{`${parseFloat(
                                  bill?.billAmount?.$numberDecimal
                                ).toFixed(2)}`}</h4>
                              ) : (
                                <h4 className="m-0">{`${parseFloat(
                                  bill?.billAmount
                                ).toFixed(2)}`}</h4>
                              )}
                            </td>
                          ) : (
                            <td  className="border-0 text-end">
                              <h4 className="m-0">{`120`}</h4>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default InvoiceView
InvoiceView.propTypes = {
  modal: PropTypes.bool,
  toggle: PropTypes.func,
  bill: PropTypes.object,
  gst: PropTypes.string,
}
